var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindowClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c2e8ff",
    d: "M1.5 1.5H14.5V14.5H1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7496c4",
    d: "M14,2v12H2V2H14 M15,1H1v14h14V1L15,1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#36404d",
    d: "M7.5 3.4H8.5V12.5H7.5z",
    transform: "rotate(-45.001 8 8)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#36404d",
    d: "M3.4 7.5H12.5V8.5H3.4z",
    transform: "rotate(-45.001 8 8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowClose);
export default __webpack_public_path__ + "static/media/window--close.336a699e16c02b82d7ca85559db68d9a.svg";
export { ForwardRef as ReactComponent };